import React, { useContext, useState } from "react";
import Context from "../../Context";
import "../../../../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Link,
  Route,
  useRouteMatch,
  useLocation,
  matchPath,
} from "react-router-dom";
import SVGShip1 from "../Misc/SvgIcons/SVGShip1";
import SVGManual from "../Misc/SvgIcons/SVGManual";
import SVGGroup1 from "../Misc/SvgIcons/SVGGroup1";

function Aside(props) {
  const cx = useContext(Context);
  const inAdmin = props.inAdmin;

  const referenceClasses = [
    "structure",
    "staff",
    "position",
    "calendar",
    "library",
    "emergency_folder",
    "vendor",
    "category",
    "model",
    "maintenance",
  ];
  let showReferenceButton = false;
  referenceClasses.forEach((essence) => {
    let access = cx.user.classAccess[essence] || {};
    if (access.c || access.u || access.d) {
      showReferenceButton = true;
    }
  });

  return (
    <div
      onMouseEnter={cx.asideMouseEnter}
      onMouseLeave={cx.asideMouseLeave}
      className={`aside aside-left  aside-fixed  d-flex flex-column flex-row-auto ${
        cx.asideIsOn ? "aside-on" : ""
      }`}
    >
      <div className="brand flex-column-auto">
        <a href="/" className="brand-logo">
          <span
            className={`text-${
              inAdmin ? "warning" : "light"
            } text-uppercase font-size-h3 font-weight-boldest`}
          >
            <span className="text-muted">Ship</span>
            {inAdmin ? "Admin" : "Safety"}
          </span>
        </a>
        <button
          onClick={cx.asideToggle}
          className="brand-toggle btn btn-sm px-0"
        >
          <span className="svg-icon svg-icon svg-icon-xl">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon points="0 0 24 0 24 24 0 24" />
                <path
                  d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                  fill="#000000"
                  fillRule="nonzero"
                  transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) "
                />
                <path
                  d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                  fill="#000000"
                  fillRule="nonzero"
                  opacity="0.3"
                  transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) "
                />
              </g>
            </svg>
          </span>
        </button>
      </div>
      <div className="aside-menu-wrapper flex-column-fluid">
        <div
          id="kt_aside_menu"
          className="aside-menu my-4 "
          data-menu-vertical="1"
          data-menu-scroll="1"
          data-menu-dropdown-timeout="500"
        >
          <PerfectScrollbar>
            <ul className="menu-nav">
              {inAdmin ? (
                <Route path="/admin">
                  <AsideLink title="Подразделения" to="/admin/areas">
                    <i className="fa fa-sitemap menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Группы" to="/admin/groups">
                    <i className="flaticon2-group menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Пользователи" to="/admin/users">
                    <i className="fa fa-address-book-o menu-icon"></i>
                  </AsideLink>
                  <hr />
                  <AsideLink title="Документооборот" to="/admin/workflow">
                    <i className="flaticon2-browser-2 menu-icon"></i>
                  </AsideLink>
                  <hr />
                  <AsideLink title="Журнал API" to="/admin/apiLog">
                    <i className="flaticon2-cardiogram menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Журнал событий" to="/admin/eventLog">
                    <i className="flaticon2-rectangular menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Реестр" to="/admin/registry">
                    <i className="flaticon2-layers menu-icon"></i>
                  </AsideLink>
                  <AsideLink title="Консоль API" to="/admin/apiConsole">
                    <i className="fa fa-plug menu-icon"></i>
                  </AsideLink>
                </Route>
              ) : null}
              {!inAdmin ? (
                <Route path="/">
                  {cx.user.getClassAccess("manual") === true ||
                  cx.user.getClassAccess("library") === true ? (
                    <AsideGroup
                      title="Документы"
                      icon={
                        <span className="svg-icon  menu-icon    ">
                          <SVGManual />
                        </span>
                      }
                      routeMatches={[
                        "/manual",
                        "/library",
                        "/workdoc",
                        "/emergency_folder",
                        "/certificate",
                        "/manualchanged",
                      ]}
                    >
                      {cx.user.getClassAccess("manual") === true ? (
                        <AsideLink title="Руководства" to="/manual/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("manual") === true ? (
                        <AsideLink title="Рабочая документация" to="/workdoc/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("certificate") === true ? (
                        <AsideLink title="Судовые документы" to="/certificate/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("library") === true ? (
                        <AsideLink title="Библиотека" to="/library/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("emergency_folder") === true ? (
                        <AsideLink
                          title="Аварийная папка"
                          to="/emergency_folder/"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("manual") === true ? (
                        <AsideLink title="Изменения" to="/manualchanged/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                    </AsideGroup>
                  ) : null}

                  {cx.user.getClassAccess("element") === true ||
                  cx.user.getClassAccess("element") === true ? (
                    <AsideGroup
                      title="Технический раздел"
                      icon={
                        <i className="svg-icon menu-icon">
                          <SVGShip1 />
                        </i>
                      }
                      routeMatches={["/element"]}
                    >
                      {cx.user.getClassAccess("element") === true ? (
                        <AsideLink title="Структура СТСиК" to="/element/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("maintenance") === true ? (
                        <AsideLink title="Конструктор ТО" to="/maint/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("product") === true ? (
                        <AsideLink title="Складские запасы" to="/product/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("techdoc") === true ? (
                        <AsideLink title="Документация" to="/techdoc/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}

                      {cx.user.getClassAccess("cistern") === true ? (
                        <AsideLink title="Судовой бункер" to="/bunker/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                      {cx.user.getClassAccess("tracker") === true ? (
                        <AsideLink title="Операции" to="/tracker/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                    </AsideGroup>
                  ) : null}
                  {cx.user.getClassAccess("crew") === true ||
                  cx.user.getClassAccess("crew") === true ? (
                    <AsideGroup
                      title="Персонал"
                      icon={
                        <i className="svg-icon menu-icon">
                          <SVGGroup1 />
                        </i>
                      }
                      routeMatches={["/crew"]}
                    >
                      {cx.user.getClassAccess("crew") === true ? (
                        <AsideLink title="Экипаж" to="/crew/">
                          <i className="menu-bullet menu-bullet-dot">
                            <span></span>
                          </i>
                        </AsideLink>
                      ) : null}
                    </AsideGroup>
                  ) : null}
                  {cx.user.getClassAccess("journal") === true ? (
                    <AsideLink title="Журналы" to="/journal">
                      <span className="svg-icon menu-icon">
                        <svg viewBox="0 0 14 14">
                          <g fill="#000000">
                            <path
                              fill="#000000"
                              opacity="0.9"
                              d="M 6.55466,11.542 C 6.10897,11.0187 5.36501,10.459 4.6445,10.1049 3.91698,9.7473 3.22595,9.5487 2.44138,9.4719 2.28669,9.4569 2.15844,9.4429 2.15639,9.4409 c -0.002,0 0.002,-1.6151 0.01,-3.5846 l 0.0132,-3.5808 0.14284,0.014 c 0.87708,0.087 1.85601,0.4184 2.59669,0.8803 0.63833,0.398 1.29749,1.0126 1.71774,1.6015 l 0.10576,0.1482 0,3.4014 c 0,1.8707 -0.008,3.401 -0.0176,3.4007 -0.01,-3e-4 -0.0861,-0.081 -0.16992,-0.1794 z m 0.72656,-3.2297 0,-3.4156 0.20424,-0.2729 C 7.74623,4.2754 8.27075,3.7505 8.61758,3.491 9.54472,2.7971 10.55044,2.405 11.70505,2.287 l 0.14648,-0.015 0,3.5858 0,3.5859 -0.16992,0.016 C 10.0739,9.6093 8.6801,10.2726 7.5899,11.4068 l -0.30868,0.3212 0,-3.4156 z m 0.9961,3.1835 c 0.63101,-0.592 1.46635,-1.0624 2.30546,-1.2985 0.4391,-0.1235 1.01012,-0.2097 1.38918,-0.2097 0.19874,0 0.30898,-0.043 0.37116,-0.1451 0.0468,-0.077 0.0473,-0.1101 0.0474,-3.0157 l 8e-5,-2.9382 0.0879,0.016 c 0.0483,0.01 0.18544,0.048 0.30468,0.086 l 0.2168,0.069 0,3.6669 c 0,2.0168 -0.008,3.6669 -0.0179,3.6669 -0.01,0 -0.15489,-0.031 -0.32227,-0.069 -0.66143,-0.149 -1.20614,-0.2002 -1.92152,-0.1809 -0.86772,0.024 -1.54209,0.145 -2.34375,0.422 l -0.30469,0.1053 0.1875,-0.1759 z m -2.67188,0.057 C 5.27252,11.4336 4.7227,11.2931 4.35153,11.2325 c -0.50468,-0.082 -0.85286,-0.1038 -1.4714,-0.09 -0.61458,0.013 -0.98632,0.056 -1.49344,0.1711 -0.1418,0.032 -0.28682,0.065 -0.32227,0.072 l -0.0644,0.014 1.1e-4,-3.6767 1.2e-4,-3.6768 0.27529,-0.08 c 0.1514,-0.044 0.28847,-0.085 0.30458,-0.09 0.0233,-0.01 0.0293,0.589 0.0293,2.9349 0,3.2057 -0.007,3.027 0.12978,3.1169 0.0476,0.031 0.1465,0.045 0.42893,0.062 1.12246,0.064 2.18752,0.4409 3.05702,1.0822 0.1875,0.1383 0.63749,0.5181 0.66328,0.5598 0.018,0.029 0.006,0.026 -0.28292,-0.078 z"
                            />
                          </g>
                        </svg>
                      </span>
                    </AsideLink>
                  ) : null}
                  {cx.user.getClassAccess("report") === true ? (
                    <AsideLink title="Отчеты" to="/report">
                      <span className="svg-icon menu-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="#000000"
                        >
                          <g fill="#000000">
                            <path
                              opacity="0.3"
                              d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM15 17C15 16.4 14.6 16 14 16H8C7.4 16 7 16.4 7 17C7 17.6 7.4 18 8 18H14C14.6 18 15 17.6 15 17ZM17 12C17 11.4 16.6 11 16 11H8C7.4 11 7 11.4 7 12C7 12.6 7.4 13 8 13H16C16.6 13 17 12.6 17 12ZM17 7C17 6.4 16.6 6 16 6H8C7.4 6 7 6.4 7 7C7 7.6 7.4 8 8 8H16C16.6 8 17 7.6 17 7Z"
                              fill="#000000"
                            />
                            <path
                              d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z"
                              fill="#000000"
                            />
                          </g>
                        </svg>
                      </span>
                    </AsideLink>
                  ) : null}
                  <hr />
                  {showReferenceButton && (
                    <AsideLink title="Параметры" to="/reference/">
                      <i className="fa fa-cogs menu-icon"></i>
                    </AsideLink>
                  )}
                </Route>
              ) : null}
            </ul>
          </PerfectScrollbar>
        </div>
      </div>
      {cx.asideIsOn ? (
        <div
          onClick={() => cx.asideToggleOnOff(false)}
          className="aside-overlay"
        ></div>
      ) : null}
    </div>
  );
}

function AsideGroup(props) {
  let [open, toggle] = useState(0);
  const location = useLocation();
  let active = false;
  props.routeMatches.forEach((path) => {
    let match = matchPath(location.pathname, {
      path,
    });
    if (match) {
      active = true;
      // open = true;
    }
  });
  return (
    <li
      className={`menu-item menu-item-submenu ${
        active ? "menu-item-active" : ""
      } ${open ? "menu-item-open" : ""}`}
      aria-haspopup="true"
      data-menu-toggle="hover"
      onClick={() => toggle(!open)}
    >
      <div className="menu-link menu-toggle">
        {props.icon}
        <span className="menu-text">{props.title}</span>
      </div>
      <div className="menu-submenu">
        <ul className="menu-subnav">{props.children}</ul>
      </div>
    </li>
  );
}

function AsideLink(props) {
  const cx = useContext(Context);
  const isOpen = useRouteMatch(props.to);
  return (
    <li
      className={`menu-item ${isOpen ? "menu-item-active" : ""}`}
      aria-haspopup="true"
      data-menu-toggle="hover"
    >
      <Link
        to={props.to}
        onClick={(e) => {
          e.stopPropagation();
          cx.asideToggleOnOff(false);
        }}
        className="menu-link"
      >
        {props.children}
        <span className="menu-text">{props.title}</span>
      </Link>
    </li>
  );
}
export default Aside;
